import "./App.module.css";
import "./utils/theme.css";
import Header from "./components/Head/Header";
import Hero from "./components/Hero/Hero";
import Portfolio from "./components/Portfolio/Portfolio";
import Testimonial from "./components/Testimonial/Testimonial";
import ParticlesBG from "./components/ParticlesBG.js";

function App() {
  return (
    <>
      <ParticlesBG />
      <Header />
      <Hero />
      <main>
        <Portfolio />
        <Testimonial />
      </main>
    </>
  );
}

export default App;
